export const PreMarketHours: number = 5
export const PreMarketMinutes: number = 30
export const PostMarketHours: number = 4
